import { connect } from "react-redux";

import AnswerStart from "components/answer/AnswerStart";

import {
  set as setAnswerStart,
  changeLocale
} from "redux/modules/answer/answerStart";
import {
  setHeaderInfo,
  startEffect,
  finishEffect,
  setAnswerToken
} from "redux/modules/answer/answerHeader";
import { init as attributeReadyInit } from "redux/modules/answer/attributeReady";
import { setLocale, setLocales } from "redux/modules/answer/answerResult";
import { openErrorDialog } from "redux/modules/errorDialog";

import history from "utils/history";
import storage from "utils/storage";
import api from "api";

const mapStateToProps = state => ({
  answerStart: state.answerStart,
  answerHeader: state.answerHeader,
  answerResult: state.answerResult
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchAnswerStart: (answerToken, localeId, urlToken, surveyId) => {
    api
      .get(`start/${surveyId}`)
      .then(res => {
        storage.setPreviewSurveyId(res.surveyId);
        dispatch(setAnswerStart(res.surveyLocales, localeId));
        dispatch(setHeaderInfo(res.headerInfo));
        dispatch(setLocales(res.surveyLocales));
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  changeLocale: localeId => {
    dispatch(changeLocale(localeId));
    // 属性開始画面を初期化する
    dispatch(attributeReadyInit());
  },
  handleStart: localeId => {
    dispatch(setLocale(localeId));

    // 画面表示用の適当な値を入れる
    dispatch(setAnswerToken("previewToken"));

    dispatch(startEffect());
    setTimeout(() => {
      history.push(`/attribute_ready`, ownProps);

      dispatch(finishEffect());
    }, 300);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AnswerStart);



// WEBPACK FOOTER //
// ./src/containers/preview/AnswerStartContainer.js